var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownNew = function SvgChevronDownNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.153 12 .433 2.74C-.07 2.204-.146 1.237.264.58S1.415-.176 1.92.359l7.209 7.654L16.052.378c.49-.56 1.23-.489 1.659.15.428.639.374 1.606-.115 2.165-.011.01-.018.019-.03.028z"
  })));
};
export default SvgChevronDownNew;